module.exports = __webpack_public_path__ + "img/covid-1.af6fbe47.png";